/**
 * 页面容器（FE-E3b 注入式下沉）：顶部 banner 含标题/副标题（不在内容区）+ 右侧操作区
 * + 内容不限宽撑满。渲染骨架与 admin/merchant 原实现逐字一致（admin 为底本）；
 * 端差异仅 extra 区 class——admin 带浮层穿透防护前缀（relative z-20 pointer-events-auto），
 * 经 extraClassName 注入（缺省= merchant 现值）。
 *
 * 历史：本文件原为 NavLink 页签版（FE2-024 收录后零端引用），FE-E3b 重写为 banner 版
 * 替换（零引用替换无行为影响，页签形态未被任何端消费）。
 * keep：agent 端为 flex-col animate-in 结构（视觉范式不同），不并入。
 */
import type { ReactNode } from 'react';

export interface PageContainerProps {
  title: string;
  /** 副标题（支持 ReactNode，如内嵌 demo-badge 标识） */
  subtitle?: ReactNode;
  /** 顶部右侧操作区（如新建按钮） */
  extra?: ReactNode;
  children: ReactNode;
  /** extra 区 class；缺省 'flex items-center gap-2'（merchant 现值），admin 注入穿透防护前缀 */
  extraClassName?: string;
}

export function PageContainer({
  title,
  subtitle,
  extra,
  children,
  extraClassName = 'flex items-center gap-2',
}: PageContainerProps) {
  return (
    <>
      {/* 顶部标题区（独立于内容，撑满宽度） */}
      <div className="px-6 pt-5 pb-4 border-b border-slate-200 bg-white">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-xl font-bold text-slate-900">{title}</h1>
            {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
          {extra && <div className={extraClassName}>{extra}</div>}
        </div>
      </div>
      {/* 内容区：撑满，不再居中限宽 */}
      <div className="p-6">{children}</div>
    </>
  );
}

export default PageContainer;
